module.exports = __webpack_public_path__ + "img/images-2.7fed8c82.jpg";